import {
  CELL_TYPE_THUMBNAIL,
  CELL_TYPE_POSTER,
  CELL_TYPE_CIRCLE,
  CELL_TYPE_LAUNCHER, THUMBNAIL
} from '@/common/constant'
export const getBandTypeInfoByCellType = (cellType) => {
  if (cellType === '') return
  const getThumbnailSet = (componentType) => {
    return Object.assign(res, componentType)
  }
  let res = {
    type: '',
    typeNumber: '',
    width: '',
    height: '',
    cellType: cellType,
    componentName: ''
  }
  switch (cellType) {
    case 'band_1': case 'band_2': case 'band_3': case 'band_4': case 'band_5': case 'band_6': case 'band_7':
    case 'band_52': case 'band_82': case 'band_myview':
      getThumbnailSet(THUMBNAIL.LANDSCAPE)
      break
    case 'band_8': case 'band_9': case 'band_10': case 'band_11': case 'band_12': case 'band_13': case 'band_14':
    case 'band_61': case 'band_94': case 'band_98':
      getThumbnailSet(THUMBNAIL.PORTRAIT)
      break
    case 'band_15': case 'band_16': case 'band_17': case 'band_18': case 'band_19': case 'band_20': case 'band_21':
      getThumbnailSet(THUMBNAIL.CIRCLE)
      break
    case 'band_31':
      getThumbnailSet(THUMBNAIL.LAUNCHER)
      break
  }
  return res
}

export const getCellListContainerClassName = (cellType) => {
  if (cellType === CELL_TYPE_THUMBNAIL || cellType === CELL_TYPE_POSTER || cellType === CELL_TYPE_CIRCLE || CELL_TYPE_LAUNCHER) {
    return `cell-list scroll cell-${cellType}`
  }
}

export const getBandTypeInfoBySmrCellType = (cellType) => {
  switch (cellType) {
    case 'mainlist':
    case 'popularlist':
    case 'newlist' :
      return getBandTypeInfoByCellType('band_1')
    case 'clipPopularProgramList':
      return getBandTypeInfoByCellType('band_13')
  }
}
